module.exports = __webpack_public_path__ + "static/media/DPL_02.eb4d6aa9.jpg";